import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps';
import TableComponent from '../../../components/table/TableOps';
import Http from '../../../Http';
import { Button } from '@material-ui/core';
import Toast from 'react-hot-toast';

class DesembarcarGuias extends TableComponent {
  id_embarque = this.props.match.params.id
  
  componentDidMount() {
    if (this.id_embarque && !isNaN(this.id_embarque)) {
      this.tableConfig(
        { dataUrl: `embarque/desembarque-guias?id_embarque=${this.id_embarque}`, deleteUrl: '', deleteField: '', modUrl: '' },
        TableOp.Table('', [
          { label: 'Desembarcar', id: 'checked', type: 'checkbox', callback: this.onValueChange },
          { label: 'Guia', id: 'g_folio' },
          { label: 'Cliente', id: 'cliente' },
          { label: 'Origen', id: 'origen' },
          { label: 'Destino', id: 'destino' },
        ], []))
      this.table();
    }
  }

  onValueChange = (event, index, field) => {
    let { tableData, guiasSelected } = this.state;
    let value = event.target.value;

    if (!guiasSelected) {
      guiasSelected = [];
    }
    if (value) {
      if (!guiasSelected.some(g => g.id === tableData.rows[index]['id'])) {
        tableData.rows[index][field] = value;
        guiasSelected.push(tableData.rows[index])
      }
    } else {
      if (guiasSelected.some(g => g.id === tableData.rows[index]['id'])) {
        guiasSelected = guiasSelected.filter(g => g.id !== tableData.rows[index]['id']);
        tableData.rows[index][field] = value;
      }
    }
    this.setState({ tableData, guiasSelected });
  }

  saveDesembarqueGuia = async () => {
    this.setState({ loading: true });
    const { guiasSelected } = this.state;
    if (!guiasSelected || guiasSelected.length === 0) {
      return Toast.error('No hay guias seleccionadas');
    }
    const id_guias = guiasSelected.map(g => g.id);
    const Resp = await Http.post(`embarque/marcar-desembarque-guias`, { id_guias, id_embarque: this.id_embarque });
    if (!Resp.error) {
      Toast.success(Resp.errMsg)
      this.setState({ guiasSelected: [], loading: false  });
      this.props.history.push(`/Guias/Embarques`);
    } else {
      Toast.error(Resp.errMsg)
      this.setState({ loading: false });
    }
  }

  async table(page = this.page, limit = this.rpp, q = this.q, orderBy = this.orderBy, order = this.order) {
		this.page = page; this.rpp = limit;
		this.setState({ loading: true })
    let guiasSelected = [];
		try {
			if (!q) {
				const urlParams = new URLSearchParams(window.location.search);
				q = urlParams.get('qt');
				let pages = urlParams.get('page');
				if (pages) {
					page = parseInt(pages);
					this.page = page;
				}
			}
			if (!this.config.dataUrl) {
				return false;
			}

			let Res = await Http.get(`${this.config.dataUrl}`);
      if (Res.data) {
        guiasSelected = Res.data.rows.filter(r => r.checked)
      }
			this.setState({ tableData: { ...this.state.tableData, rows: Res.data.rows, total: Res.data.total, q, page: this.page }, loading: false, guiasSelected });
			return Res.data.rows;
		} catch (error) {
			Toast.error(`Ocurrio un error inesperado (LCL1)`)
			this.setState({ loading: false })
		}
		return [];
	}

  render() {
    const { guiasSelected = [], loading } = this.state
    return (
      <div>
        <h4>Desembarque Guias - Embarque #{this.id_embarque}</h4>
        <div>
          Guias Seleccionadas: {guiasSelected.map(g => g.g_folio).join(', ')}
        </div>
        <this.TableRender pagination={false} />
        <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', margin: 10 }} >
          <Button style={{ marginRight: 10 }} variant="contained" color='primary' onClick={() => { this.props.onClose() }} >Regresar</Button>
          <Button disabled={loading} variant="contained" color='secondary' onClick={() => { this.saveDesembarqueGuia() }} >Marcar Desembarque de Guias</Button>
        </div>
      </div>
    )
  }
}

export default withRouter(DesembarcarGuias)